import { render, staticRenderFns } from "./Form.Categories.Item.vue?vue&type=template&id=d75c6138&scoped=true"
import script from "./Form.Categories.Item.vue?vue&type=script&lang=js"
export * from "./Form.Categories.Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75c6138",
  null
  
)

export default component.exports